import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PictureAsPdfIcon(props: IconProps) {
    return <Icon {...props} iconKey={"picture_as_pdf"}/>
}
